"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LoadingMessage = require("./LoadingMessage");

var _default = _LoadingMessage.LoadingMessage;
exports["default"] = _default;